import BaseMetricHandler from "./BaseMetricHandler";
import { getHexFromScoreRatio } from "../../components/commons/ScoringScaleSlider";

function getScoreColor(score) {
  let colors = {
    1: getHexFromScoreRatio(0.05),
    2: getHexFromScoreRatio(0.25),
    3: getHexFromScoreRatio(0.5),
    4: getHexFromScoreRatio(0.75),
    5: getHexFromScoreRatio(1),
    Yes: getHexFromScoreRatio(1),
    No: getHexFromScoreRatio(0.02),
    Maybe: getHexFromScoreRatio(0.5),
    "Strong Yes": getHexFromScoreRatio(1),
    "Weak Yes": getHexFromScoreRatio(0.66),
    "Weak No": getHexFromScoreRatio(0.33),
    "Strong No": getHexFromScoreRatio(0.05),
    "Strong proceed": getHexFromScoreRatio(1),
    Proceed: getHexFromScoreRatio(0.67),
    Reject: getHexFromScoreRatio(0.34),
    "Strong reject": getHexFromScoreRatio(0.1),
  };
  return colors[score] || "";
}

export default class InterviewScoreCountsHandler extends BaseMetricHandler {
  constructor(groupBy, filterBy) {
    super(groupBy, filterBy);
    this.graphType = "";
    this.dataType = "counts";
  }

  getGraphOptions(backendData) {
    let series = backendData.data
      .map((series, index) => {
        return {
          name: backendData.labels[index],
          type: "bar",
          stack: true,
          color: getScoreColor(backendData.labels[index]),
          data: series,
        };
      })
      .slice(0, BaseMetricHandler.MaxLabels());

    let options = {
      notMerge: true,
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: backendData.labels.slice(0, BaseMetricHandler.MaxLabels()),
        top: "bottom",
      },
      grid: {
        left: "0%",
        right: "0%",
        bottom: "15%",
        containLabel: true,
      },
      toolbox: {
        // feature: {
        //   saveAsImage: {},
        // },
      },
      xAxis: {
        type: "category",
        boundaryGap: true,
        data: backendData.xAxis,
      },
      yAxis: {
        type: "value",
      },
      series: series,
    };
    return options;
  }
}
